import React from "react";
import CardSection from "../../../components/ui/CardSection";
import SummaryRow from "../../../components/ui/SummaryRow";
import { ISalePayment } from "../../../classes/interfaces";
import { formatBRL } from "../../../helpers/currency.helper";

interface PaymentsListProps {
  payments: ISalePayment[];
}

export default function PaymentsList({ payments }: PaymentsListProps) {
  return (
    <CardSection icon="card" title="Pagamentos">
      {payments.map((payment, index) => (
        <SummaryRow key={index} label={payment.name || ""} value={formatBRL(payment.value)} />
      ))}
    </CardSection>
  );
}
